module.exports = __webpack_public_path__ + "static/media/link_symbol.1b3f967d.svg";